<template>
	<!-- <div class="protected" v-if="loginSuccess">
        <h1>
            <b-badge variant="success">보안 사이트에 대한 액세스가 허용되었습니다</b-badge>
        </h1>
        <h5>로그인 성공!</h5>
    </div> -->

	<section class="bg-account-pages vh-100 d-flex align-items-center bg-center position-relative">
		<div class="container" id="app">
			<div class="row justify-content-center">
				<div class="col-md-8 col-lg-6 col-xl-5">
					<div class="bg-white shadow">
						<div class="p-4">
							<div class="text-center mt-3">
								<a href="/" class="logo">
									<img src="../../../images/logo-dark.png" alt="" class="logo-dark" height="30" />
								</a>
								<p class="title-signup">로그인</p>
							</div>
							<div class="p-3">
								<form method="post" @submit="submitLogin" class="av-invalid" id="frm-login">
									<div class="mb-3">
										<input id="email" v-model="email" name="email" placeholder="이메일" class="form-control" />
									</div>
									<div class="mb-3">
										<input name="password" placeholder="비밀번호" v-model="password" id="password" type="password" class="form-control" value="" />
									</div>
									<div class="form-check">
										<input class="form-check-input" type="checkbox" v-model="rememberMe" value="" name="remember-me" id="remember-me" />
										<label class="form-check-label" for="remember-Check">로그인 상태 유지</label>
									</div>
									<div class="d-grid mt-3">
										<button id="submit-button" type="submit" value="Submit" class="btn btn-primary btn-none">로그인</button>
									</div>
								</form>
								<div class="d-grid mt-3">
									<button v-on:click="submitSigninNaver" id="submit-naver" type="submit" value="Submit" class="btn btn-naverlogin btn-none naverlogin-container">
										<img class="naverlogin-square" src="../../../images/naverlogin_square.png" />
										<div class="naverlogin-text">네이버 아이디로 로그인</div>
									</button>
								</div>
								<div class="mt-4 mb-0 text-center">
									<router-link to="/resetpw/email" class="text-dark"> <i class="icon-xs icon me-1" data-feather="lock"></i>비밀번호 찾기/재설정 </router-link>
								</div>
							</div>
						</div>
					</div>
					<div class="text-center mt-4">
						<p>아직 계정이 없으신가요?<router-link to="/signup" class="font-weight-semibold text-primary"> 가입하기</router-link></p>
					</div>
				</div>
				<!-- end col -->
			</div>
			<!-- end row -->
		</div>
		<!-- end container -->
	</section>
</template>

<script>
import Swal from "../../../js/sweetalert2.min.js";
import axios from "axios";

export default {
	data() {
		return {
			loginSuccess: false,
			email: "",
			password: "",
			password2: "",
			rememberMe: false
		};
	},
	methods: {
		selectAll: function() {
			this.checkSub = [];
			if (!this.allSelected) {
				for (const user in this.users) {
					this.checkSub.push(this.users[user].id.toString());
				}
			} else {
				this.checkSub = [];
			}
		},
		select: function() {
			if (this.checkSub.length == 4) {
				this.allSelected = true;
			} else {
				this.allSelected = false;
			}
		},
		validEmail: function(email) {
			var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(email);
		},
		validPassword: function(password) {
			var re = /(?=.*\d)(?=.*[a-z]).{8,16}/;
			return re.test(password);
		},
		submitLogin: function(e) {
			e.preventDefault();
			// 아이디 중복확인
			// 이메일 유효성 확인
			// 비밀번호 유효성 확인
			// 비밀번호끼리 일치하는 지 확인
			this.errors = [];

			if (!this.email) {
				this.errors.push("이메일을 입력해주세요.");
			} else if (!this.password) {
				this.errors.push("비밀번호를 입력해주세요.");
			} else if (this.password.length < 8) {
				this.errors.push("아이디 또는 비밀번호를 잘못 입력 하셨습니다.");
			} else if (this.password.length > 16) {
				this.errors.push("아이디 또는 비밀번호를 잘못 입력 하셨습니다.");
			} else if (!this.validPassword(this.password)) {
				this.errors.push("아이디 또는 비밀번호를 잘못 입력 하셨습니다.");
			}

			if (this.errors.length) {
				swal(this.errors[0]);
				return true;
			} else {
				var form = new FormData();
				form.append("username", this.email);
				form.append("password", this.password);
				form.append("remember-me", this.rememberMe);

				this.loginSuccess = false;
				Swal.showLoading();
				axios
					.post("/loginProcess", form)

					.then(response => {
						Swal.close();
						if (response.status == 200) {
							let redirectUrl = response.data.url;
							if (redirectUrl == null || redirectUrl == "signin") {
								redirectUrl = "/main";
							}
							let msg = "환영합니다.\n로그인 성공했습니다.";
							this.loginSuccess = true;
							swal(msg, {
								buttons: false,
								timer: 1500
							});
							setTimeout(() => {
								location.replace(redirectUrl);
							}, 1500);
						} else {
							msg = "알 수 없는 문제가 발생하여 로그인에 실패했습니다.\n관리자에게 문의해주세요.\n code -2";
							swal(msg, {
								buttons: false,
								timer: 1500
							});
						}
					})
					.catch(error => {
						Swal.close();
						let msg = "이메일 또는 비밀번호를 다시 확인하세요.";
						if (error.response.status == 401) {
							let exception = error.response.data;
							if (exception == "UsernameNotFoundException") {
								msg = "존재하지 않는 이메일입니다.";
							} else if (exception == "BadCredentialsException") {
								msg = "이메일 또는 비밀번호를 다시 확인하세요.";
							}

							swal(msg, {
								buttons: false,
								timer: 3000
							});
						} else {
							msg = "알 수 없는 문제가 발생하여 로그인에 실패했습니다.\n관리자에게 문의해주세요.\n code -3";
							swal(msg, {
								buttons: false,
								timer: 1500
							});
						}
					});
			}
		},
		submitSigninNaver: function(e) {
			e.preventDefault();
			var state = Date.now() + "_login";
			let naverLoginUrl = "https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=BkKeJIguGeMnSLkq7Pps" + "&state=" + state + "&redirect_uri=";

			if (window.location.host == "localhost:8080") {
				naverLoginUrl += "http%3A%2F%2Flocalhost%3A8080%2Fanonymous%2Foauth%2Fnaver%2Fcallback";
			} else {
				naverLoginUrl += "https%3A%2F%2Fwww.myparang.io%2Fanonymous%2Foauth%2Fnaver%2Fcallback";
			}

			location.href = naverLoginUrl;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/user/Login.vue